/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export interface RequestDto {
    id: number;
    collector: number;
    artist: number;
    artworkId: number;
    status: RequestDto.status;
}

export namespace RequestDto {

    export enum status {
        PENDING = 'pending',
        REJECTED = 'rejected',
        FULFILLED = 'fulfilled',
    }


}



// WEBPACK FOOTER //
// ./src/services/openapi/generated/models/RequestDto.ts